import { useMediaQuery } from "../../hooks/useMediaQuery"
import ButtonUI from "../UI/ButtonUI/ButtonUI"
import {getPickupType} from "../../utils/format";
import {formatDeliveryDate} from "../../utils/date";

export default function PickupDetail({
    data,
    onClose,
    onClick,
    buttonText = 'Заберу здесь',
    hasButton = true,
    disabled = false
}) {
    const isTablet = useMediaQuery('(max-width: 992px)')
    
    if (!data) return null

    return (
        <div className="pickup-detail">
            {hasButton && !isTablet && <button className="pickup-detail__close" onClick={onClose}>
                <img src="/files/images/icons/arrow.svg" alt="Назад" />
            </button>}

           <div className="pickup-detail__body">
                <h3 className="pickup-detail__title">{data.service ?? getPickupType(data.pickupType)}</h3>
                <span className="pickup-detail__address">{data.street || data.address}</span>

                <hr />

               {
                   (data.deliveryNotice || data.deliveryTerm) && (
                       <div className="pickup-detail__info">
                           <span className="pickup-detail__info-title">{data.deliveryNotice ? 'Отправка' : 'Дата доставки'}</span>
                           <span className="pickup-detail__info-value">{data.deliveryNotice || formatDeliveryDate(data.deliveryTerm)}</span>
                       </div>
                   )
               }


                <div className="pickup-detail__info">
                    <span className="pickup-detail__info-title">Время работы</span>
                    <span className="pickup-detail__info-value">{data.work_time}</span>
                </div>

                {data.phone && Array.isArray(data.phone) && (
                    <div className="pickup-detail__info">
                        <span className="pickup-detail__info-title">Телефон</span>
                        <span className="pickup-detail__info-value">
                            {data.phone.map((phoneObj, index) => (
                                <span key={index}>
                                    <a href={`tel:${phoneObj.number}`}>
                                        {phoneObj.number}
                                    </a>
                                    {index < data.phone.length - 1 && ', '}
                                </span>
                            ))}
                        </span>
                    </div>
                )}

                {data.address_comment && (
                    <div className="pickup-detail__info">
                        <span className="pickup-detail__info-title">Как добраться</span>
                        <span className="pickup-detail__info-value">{data.address_comment}</span>
                    </div>
                )}
                
                {typeof data.is_dressing_room === 'boolean' && !data.is_dressing_room && (
                    <div className="pickup-detail__info">
                        <span className="pickup-detail__warn">Примерки нет</span>
                    </div>
                )}
           </div>

           {hasButton && <ButtonUI className="pickup-detail__button" text={buttonText} onClick={onClick} disabled={disabled} />}
        </div>
    )
}
